<template>
  <img :src="url" @error="handleError" />
</template>

<script>
import { getAvatarApi } from '@/api/Site/Create'
export default {
  props: ['spiderId', 'address', 'type'],
  data() {
    return {
      // url: 'https://i.loli.net/2021/07/02/NMO1fV3Icjd8CZ9.png',
      url: '',
      defaultImg: {
        weibo: require('./imgs/weibo.png'),
        news: require('./imgs/news.png'),
        toutiao: require('./imgs/toutiao.png'),
        facebook: require('./imgs/facbook.png'),
        twitter: require('./imgs/twitter.png'),
        api: require('./imgs/api.png'),
        document: require('./imgs/document.png'),
        youtube: require('./imgs/youtube.png')
      }
    }
  },

  methods: {
    async getAvatar() {
      let data = {
        imageAddress: this.address,
        type: this.type
      }
      if (this.spiderId) {
        data.spiderId = this.spiderId
      }
      let res = await getAvatarApi(data)
      let { extra, code } = res
      if (code == 200) {
        this.url = extra.headImage
      } else {
        this.url = this.defaultImg[this.type]
      }
    },

    handleError() {
      this.url = this.defaultImg[this.type]
    }
  },
  watch: {
    address: {
      handler() {
        if (this.address && this.type) {
          this.getAvatar()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
</style>
